import { BaseEntity } from '../../../models';
import { Cidade } from '../../cidade';
import { RegiaoCidadeSubRegiao } from './sub-regiao';

export class RegiaoCidade implements BaseEntity {
    readonly id: number;
    idRegiao: number;
    idCidade: number;
    cidade: Cidade;
    subRegioes: RegiaoCidadeSubRegiao[];

    constructor() {
        this.subRegioes = [];
    }
}
